import { Layout } from './layout.model';

export class KioskLayout implements Layout {
  hasStatusBar: boolean = true;
  hasMenu: boolean = false;
  hasLayout: boolean = true;
  hasLayoutPadding = false;
  autoHideStatusBar = true;
}
